// src/pages/CalculatorsPage.js
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';
import { Breadcrumb, usePageTitle } from '../components/layout/PageBits';
import SipLumpTool from '../components/calculators/SipLumpTool';
import RetirementCalculator from '../components/RetirementCalculator';
import ChildEducationCalculator from '../components/ChildEducationCalculator';
import ChildMarriageCalculator from '../components/ChildMarriageCalculator';
import OtherGoalCalculator from '../components/OtherGoalCalculator';
import InflationCalculator from '../components/InflationCalculator';

// Tool-first page: no hero. The list doubles as chips on phones and a sidebar on desktop.
const CALCS = [
  ['sip', 'cl1', '📈'], ['lump', 'cl2', '💰'], ['retirement', 'cl3', '🌅'], ['education', 'cl4', '🎓'],
  ['marriage', 'cl5', '💍'], ['inflation', 'cl6', '🔥'], ['goal', 'cl7', '🎯'],
];
const LEGACY = { retirement: RetirementCalculator, education: ChildEducationCalculator, marriage: ChildMarriageCalculator, inflation: InflationCalculator, goal: OtherGoalCalculator };

function CalculatorsPage() {
  const { lang, t } = useLang();
  const [params, setParams] = useSearchParams();
  const active = CALCS.some(([id]) => id === params.get('c')) ? params.get('c') : 'sip';
  const [amount, setAmount] = useState({ sip: 10000, lump: 100000 });
  const [rate, setRate] = useState(12);
  const [years, setYears] = useState(10);
  usePageTitle(t('calcTitle'));

  const choose = (id) => setParams(id === 'sip' ? {} : { c: id }, { replace: true });
  const mode = active === 'lump' ? 'lump' : 'sip';
  const Legacy = LEGACY[active];

  return (
    <div className="bg-[#F5F7FB] min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <Breadcrumb current={t('calcTitle')} />
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-2 mb-6">
          <h1 className="text-3xl font-extrabold">{t('calcTitle')}</h1>
          <p className="text-slate-500 max-w-md text-sm">{t('calcSub')}</p>
        </div>
        <div className="grid lg:grid-cols-[230px_1fr] gap-6">
          <aside className="min-w-0 lg:sticky lg:top-24 h-fit">
            <nav className="flex lg:flex-col gap-2 overflow-x-auto pb-1 lg:pb-0 -mx-4 px-4 lg:mx-0 lg:px-0" aria-label={t('calcTitle')}>
              {CALCS.map(([id, key, ic]) => (
                <button key={id} type="button" onClick={() => choose(id)} aria-current={active === id ? 'page' : undefined}
                  className={`shrink-0 flex items-center gap-2.5 px-3.5 py-2.5 rounded-xl text-sm font-semibold text-left transition ${active === id ? 'bg-brand text-white shadow' : 'bg-white border border-slate-200 text-slate-700 hover:border-brand'}`}>
                  <span aria-hidden="true">{ic}</span>{t(key)}
                </button>
              ))}
            </nav>
          </aside>
          <section className="min-w-0">
            {Legacy ? (
              <div className="bg-white rounded-3xl shadow-sm border border-slate-200 p-3 sm:p-6 overflow-hidden">
                {lang === 'bn' && <p className="text-xs text-slate-500 mb-3">{t('enOnlyNote')}</p>}
                <Legacy />
              </div>
            ) : (
              <SipLumpTool
                mode={mode}
                onMode={(m) => choose(m)}
                amount={amount[mode]}
                setAmount={(v) => setAmount((a) => ({ ...a, [mode]: v }))}
                rate={rate} setRate={setRate} years={years} setYears={setYears}
              />
            )}
          </section>
        </div>
      </div>
    </div>
  );
}

export default CalculatorsPage;
